import React, { useState, useMemo, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, Spinner, Alert } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { getArticleList } from '../../../../slices/thunks';
import OSelect from '../../../../Components/OElements/OSelect';
import { getNormativeList } from '../../../../helpers/normative/backend_helper';

const FetchArticleModal = ({ handleClickFetchArticle, onArticleSelected }) => {
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            keyword: '',
            normative_id: '',
        },
        validationSchema: Yup.object({
            keyword: Yup.string().nullable(),
            normative_id: Yup.string().nullable(),
        }),
        onSubmit: async (values) => {
            // Handle form submission
        },
    });

    const dispatch = useDispatch();

    const [articleSelected, setArticleSelected] = useState([]);

    const selectorArticle = createSelector(
        state => state.Article,
        data => ({
            dataList: data.articleList || [],
            isLoadingList: data.isLoadingList,
        })
    );

    const { dataList, isLoadingList } = useSelector(selectorArticle);

    const handleSearch = () => {
        if (validation.values.keyword || validation.values.normative_id) {
            dispatch(getArticleList({ normative_id: validation.values.normative_id, keyword: validation.values.keyword }));
        }
    };

    const [selectedNormative, handleNormativeSelected] = useState(null);
    const [selectionList, setSelectionList] = useState({});

    useEffect(() => {
        if (Object.keys(selectionList).length > 0 && dataList.length > 0) {
            let selectionItems = [];
            Object.entries(selectionList).forEach(([key, value]) => {
                if (key != null) {
                    const item = dataList.find(item => item._id === key);
                    if (item) {
                        selectionItems.push(item);
                    }
                }
            });
            setArticleSelected(selectionItems);
        }
    }, [selectionList]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const selectedItems = Object.keys(selectionList).map(key => dataList.find(item => item._id === key));

        onArticleSelected(articleSelected)
        handleClickFetchArticle(); // Close the modal
    };

    const columns = useMemo(
        () => [
            { header: 'Normativa', accessorKey: 'normative.name',  size: 'auto' },
            { header: 'Artículo', accessorKey: 'article',  size: 'auto' },
        ],
        []
    );

    return (
        <React.Fragment>
            <Form className='tablelist-form' onSubmit={handleSubmit}>
                <ModalBody>
                    <Row className='g-3 align-items-end'>
                        <Col lg={3}>
                            <Label for='keyword' className='form-label'>
                                Palabra clave
                            </Label>
                            <Input
                                name='keyword'
                                id='keyword'
                                className='form-control'
                                placeholder='Ingrese una palabra clave'
                                type='text'
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.keyword || ''}
                            />
                        </Col>

                        <Col lg={7}>
                            <OSelect
                                key='normative_id'
                                label='Normativa'
                                id='normative_id'
                                name='normative_id'
                                value={validation.values.normative_id || ''}
                                onSelect={handleNormativeSelected}
                                requestApi={() => getNormativeList()}
                                validation={validation}
                            />
                        </Col>
                        <Col lg={2}>
                            <button
                                type='button'
                                className='btn btn-label btn-primary w-100'
                                id='add-btn-article'
                                onClick={handleSearch}
                            >
                                <i className="ri-search-line label-icon"></i> Buscar
                            </button>
                        </Col>
                        <Col lg={12}>
                            <Label for='article' className='form-label'>
                                Artículo encontrados
                            </Label>
                            <ODataGrid
                                columns={columns}
                                data={dataList || []}
                                getRowIdTable={(originalRow) => originalRow._id}
                                selectAllMode={'all'}
                                selection={{
                                    rowSelection: selectionList,
                                    setRowSelection: setSelectionList,
                                }}
                            />
                        </Col>
                    </Row>
                </ModalBody>

                <div className='modal-footer'>
                    <div className='hstack gap-2 justify-content-end'>
                        <Button
                            type='button'
                            onClick={() => {
                                handleClickFetchArticle();
                            }} className='btn-danger btn-label'>
                            <i className="icon-x label-icon"></i>
                            Cancelar
                        </Button>
                        <button
                            type='submit'
                            className='btn btn-label btn-primary'
                            id='add-btn'
                        >
                            <i className={`${Icons.check} label-icon`}></i>
                            Seleccionar
                        </button>
                    </div>
                </div>
            </Form>
        </React.Fragment>
    );
};

export default FetchArticleModal;
